<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  label: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: undefined },
})

const emit = defineEmits(["update:modelValue", "change"])

function onChange(e) {
  const val = e.target.checked
  emit("update:modelValue", val)
  emit("change", val)
}
</script>

<template>
  <!-- group lets us show a subtle focus ring when tabbing -->
  <label
    class="group inline-flex items-center gap-2 select-none cursor-pointer"
    :for="id"
  >
    <!-- Keep a native checkbox for accessibility -->
    <input
      :id="id"
      type="checkbox"
      class="sr-only"
      :checked="modelValue"
      :disabled="disabled"
      :aria-checked="modelValue ? 'true' : 'false'"
      @change="onChange"
    />

    <!-- Visual control: always white box; check appears when checked -->
    <span
      class="relative grid place-items-center w-5 h-5 rounded-md bg-white shadow-sm
             transition-all duration-150
             group-focus-within:ring-2 group-focus-within:ring-black/15"
      :class="[
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        modelValue ? 'border-2 border-slate-900' : 'border-2 border-slate-700'
      ]"
      aria-hidden="true"
    >
      <!-- Checkmark appears only when checked -->
      <svg
        v-if="modelValue"
        width="16" height="16" viewBox="0 0 20 20" fill="none"
      >
        <path
          d="M5 10.5l3 3 7-7"
          stroke="#0f172a"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>

    <!-- Optional label text -->
    <span v-if="label" class="text-sm text-foreground/90">{{ label }}</span>
    <slot />
  </label>
</template>

<style scoped>
/* Same helper you already use elsewhere */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
